<semeris-header>
  <ng-template #title>
    <div class="conversation-title-container">
      <h2>Related Notes<mat-icon semerisHelpTrigger helpId="notes-sidebar.html" color="accent">help_outline</mat-icon></h2>
    </div>
  </ng-template>

  <ng-template #rightSide>
    <div class="conversation-sidebar-actions">
      <button (click)="onClose()" semerisIconButton fastTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </ng-template>
</semeris-header>

<div class="conversation-siderbar-content">
  <semeris-loader [loading]="loading$ | async"></semeris-loader>
  @if (conversations$ | async; as conversations) {
    <semeris-conversation-activity-list
      [canOpenInSidebar]="false"
      [labels]="labels$ | async"
      [placeholderText]="placeholderMessage$ | async"
      [users]="users$ | async"
      (labelCreated)="onLabelCreated($event)"
      [items]="conversations"
      [loading]="loading$ | async"
      (refreshList)="onRefreshList()"
      (paragraphSelected)="onParagraphSelected($event)"
      (showSourceReferences)="onShowSourceReferences($event)"
    ></semeris-conversation-activity-list>
  }
</div>
<div *permissions="[Permission.WRITE_COMMENT]" class="conversation-sidebar-new-thread">
  @if (pendingConversation$ | async; as pendingConversation) {
    <semeris-conversation-input
      [anchors]="pendingConversation.anchors"
      [labels]="labels$ | async"
      [context]="pendingConversation.context"
      [contextSource]="pendingConversation.contextSource"
      [selectedLabels]="pendingConversation.labels"
      [message]="pendingConversation.message"
      [users]="users$ | async"
      [selectedAssignees]="pendingConversation.assignees"
      [host]="true"
      (send)="onConversationComment($event)"
      (discard)="onDiscard()"
    ></semeris-conversation-input>
  } @else {
    <semeris-comment-input placeholder="Create a note..." (send)="onComment($event)"> </semeris-comment-input>
  }
</div>
